<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()" />
		</div>
		<div class="item_wrap">
			<div class="tabs" style="display: none;">
				<div class="tabs-head">
					<div class="tabs-head-scroll">
						<div v-for="(item, index) in tabs1" class="tab-item"
							:class="active == index ? 'tab-item-active' : ''" @click="sort(index)">
							<div class="tab-icon">
								<img :src="item.icon" alt="">
							</div>
							<div class="tab-title">
								{{ item.title }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="items_3 item_margin">
				<van-empty v-if="listLength == 0" :description="$t('item.noData')" />
				<div v-for="i in data.list" :key="i.id" class="item">
					<div class="item_border">
						<div class="item_div1">
							<img v-if="i.cover" class="icon round" :src="i.cover" alt="">
							<img v-else class="icon round" src="../images/invest/bi.png" alt="">
							<p>
								{{ i[lang] }}
							</p>
						</div>
						<div class="item_div2">
							<div class="item_rate">
								<p>国债证券</p>
								<p>{{ i.security }}券</p>
							</div>
							<div class="item_day">
								<p>每日提现额度</p>
								<p>+{{ i.withdrawal_limit }}元</p>
							</div>
							<div class="item_min">
								<p>售价</p>
								<p>{{ i.price }}元</p>
							</div>
						</div>
						<div class="item_div4">
							<div class="item_btn">
								<button v-if="i.switch == 1" type="button" @click="buy(i)">
									立即抢购
								</button>
								<button v-if="i.switch == 0" class="item_btn_over" type="button">
									已售罄
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<van-dialog v-model="show_tz" theme="round-button" :confirm-button-text="$t('utils.confirm')"
				@confirm="handlePayment">
				<div class="close-x" @click="show_tz = false">
					<van-icon name="cross" />
				</div>
				<div class="payment-container">
					<span>选择支付方式</span>
					<div v-for="item in paymentMethods" :key="item.value" class="payment-method"
						:class="{ active: selectedMethod === item.value }" @click="selectMethod(item.value,item.id)">
						<input type="radio" :id="item.value" :value="item.value" v-model="selectedMethod" hidden>
						<img :src="item.icon" class="method-icon">
						<label :for="item.value">{{ item.label }}</label>
					</div>
				</div>
			</van-dialog>
		</div>
	</div>
</template>
<script>
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	import Vue from 'vue';
	import {
		Tab,
		Tabs,
		Progress,
		Empty,
		Dialog,
		Field,
		Sticky,
		Switch
	} from 'vant';
	Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field).use(Sticky).use(Switch);
	export default {
		name: "Item",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				tabs: [
					this.$t('item.all'),
					this.$t('item.tab1'),
					this.$t('item.tab2'),
					this.$t('item.tab3'),
					this.$t('item.tab4'),
					this.$t('item.tab5')
				],
				tabs1: [{
					icon: require('../images/invest/icon1.png'),
					title: this.$t('item.all')
				}, {
					icon: require('../images/invest/icon2.png'),
					title: this.$t('item.tab1')
				}, {
					icon: require('../images/invest/icon3.png'),
					title: this.$t('item.tab2')
				}, {
					icon: require('../images/invest/icon4.png'),
					title: this.$t('item.tab3')
				}, {
					icon: require('../images/invest/icon1.png'),
					title: this.$t('item.tab4')
				}, {
					icon: require('../images/invest/icon2.png'),
					title: this.$t('item.tab5')
				}],
				active: 0,
				auto_close: [],
				data: [],
				listLength: 0,
				show_tz: false,
				number: "",
				sku: [],
				checked: true,
				selectedMethod: '',
				paymentMethods: [{
						value: '8010',
						id: '2',
						label: '支付宝支付',
						icon: require('../images/user/payzfb.png')
					},
					{
						value: '8009',
						id: '3',
						label: '微信支付',
						icon: require('../images/user/paywx.png')
					},
					{
						value: '8011',
						id: '4',
						label: '云闪付支付',
						icon: require('../images/user/payysf.png')
					}
				]
			}
		},
		created() {
			this.$parent.footer('item');
		},
		mounted() {
			var type = 0;
			if (this.$router.history.current.query.type) {
				this.active = parseInt(this.$router.history.current.query.type);
			}
			this.start(type);
		},
		methods: {
			start(type) {
				Fetch('/index/item_search', {
					name: "",
					index_type: type
				}).then(r => {
					this.data = r.data;
					this.listLength = r.data.list.length;
				})
				Fetch('/index/item_auto').then((r) => {
					for (var i = 0; i < r.data.ids.length; i++) {
						this.auto_close.push(parseInt(r.data.ids[i]));
					}
				});
			},
			sort(type) {
				this.active = type
				this.start(type);
			},
			changeAuto(e) {
				console.log(e)
				Fetch("/index/item_auto_c", {
					pid: this.sku.id,
					tz_auto: this.checked ? 1 : 0
				}).then(r => {}).catch(err => {
					this.psd_val = '';
				})
			},
			selectMethod(item, id) {
				this.selectedMethod = item
				this.id = id
			},
			handlePayment() {
				const productId = this.selectedMethod;
				const money = this.sku.price;
				const id = this.sku.id;
				Fetch('/index/item_apply', {
					productId,
					money,
					id
				}).then(res => {
					window.location.href = res.data.payUrl;
					// window.open(res.data.payUrl, '_blank');
					this.$toast({
						className: "toastName",
						message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
					});
				}).catch(error => {
					this.$toast({
						className: "toastName",
						message: '操作失败，请联系客服',
					});
				});
			},
			buy(item) {
				this.sku = item;
				if (this.auto_close.indexOf(item.id) != -1) {
					this.checked = false;
				} else {
					this.checked = true;
				}
				this.show_tz = true;
			},
			// confirm() {
			// 	if (!this.number) {
			// 		this.$toast({
			// 			className: "toastName",
			// 			message: this.$t('item.inputAmount'),
			// 		});
			// 		return false;
			// 	}
			// 	Fetch("/index/item_apply", {
			// 		id: this.sku.id,
			// 		money: this.number
			// 	}).then(r => {
			// 		this.$router.push("/order");
			// 	}).catch(err => {
			// 		// this.psd_val = '';
			// 	})
			// }

		}
	}
</script>

<style lang="less" scoped>
	/deep/ .van-cell {
		padding: 15px 26px;
	}

	.tabs {
		background-color: #fff;
		padding: 16px 0 10px 0;
		border-bottom: 1px solid #ececec;
		position: fixed;
		width: 100%;
	}

	.tabs-head {
		height: 73px;
		overflow: hidden;
		position: relative;

		.tabs-head-scroll {
			width: 100%;
			height: 80px;
			overflow: scroll;
			white-space: nowrap;

			.tab-item {
				display: inline-block;
				text-align: center;
				width: 25%;
				// margin-right: 28px;

				.tab-icon {
					height: 51px;

					img {
						height: 100%;
					}
				}

				.tab-title {
					padding: 5px 0;
					color: #666666;
				}
			}

			.tab-item-active {
				.tab-title {
					color: #333333;
				}
			}
		}
	}

	.red_top_bg {
		position: fixed;
		top: 0;
		z-index: 10;
		// background-color: #e40611;
		// background-image: linear-gradient(to right, #ff5252, #ff8244);

		.msg {
			position: absolute;
			top: 15px;
			right: 15px;
			height: 18px;

			img {
				height: 100%;
			}
		}
	}

	.basic_wrap {
		position: relative;
		// margin-top: 20px;
		background-image: url(../images/user/item.png);
		// background-position: center;
		background-repeat: round;
		background-size: contain;
		height: 680px;
	}

	.item_wrap {
		width: 100%;
		// padding: 44px 0 0 0;
		padding-top: 155px;

		.tabs {
			z-index: 100;
		}
	}

	// .item_margin {
	// 	margin-top: 109px !important;
	// }

	.items_3 {
		margin: 10px 15px;

		.item {
			background: #FFFFFF;
		}
	}

	.items_3 {
		.item {
			margin-bottom: 10px;
			border-radius: 10px;
			overflow: hidden;
			background: linear-gradient(to right, #f5e5cc, #f9cfa7);
			// background: linear-gradient(to right, #fbe2c8, #eab18e);
			// border: 1px solid #ebebeb;
			box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
			padding: 10px;

			// div{
			// 	margin: 5px 0;
			// }
			.item_border {
				border: 1px solid #998066;
				border-radius: 10px;
				padding: 10px;
			}

			.item_div1 {
				display: flex;
				align-items: center;
				// border-bottom: 1px solid #ECECEC;
				// padding: 4px 10px;
				// background-color: #f5f5f5;

				p:nth-child(2) {
					// width: 90%;
					// font-weight: bold;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					font-size: 15px;
					color: #998270;
				}

				p:nth-child(3) {
					color: #999;
				}

				.icon {
					width: 20px;
					height: 20px;
					margin-right: 8px;
				}
			}

			.item_div2 {
				display: flex;
				justify-content: space-between;
				text-align: center;
				padding: 12px 0;
				font-size: 14px;

				div {
					width: 33.33%;

					p {
						padding: 5px 0;
					}
				}

				.item_rate {
					p:nth-child(1) {
						// font-weight: bold;
						// color: #FF0000;
						font-size: 13px;

					}

					p:nth-child(2) {
						color: #9a3d40;
						font-size: 13px;
					}
				}

				.item_day {
					p:nth-child(1) {
						// font-weight: bold;
						font-size: 13px;
					}

					p:nth-child(2) {
						color: #9a3d40;
						font-size: 13px;
					}
				}

				.item_min {
					p:nth-child(1) {
						// font-weight: bold;
						font-size: 13px;

					}

					p:nth-child(2) {
						color: #9a3d40;
						font-size: 13px;
					}
				}
			}

			.item_div3 {
				color: #000;
				padding: 0 12px;
			}

			.item_div4 {
				padding: 0 12px 10px;
				// display: flex;
				// align-items: center;
				// justify-content: space-between;


				.item_progress {
					width: 71%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					background-color: #e9e9e9;
					padding: 0 4px;
					border-radius: 12px;

					.progress_bd {
						width: 75%;
					}

					span {
						color: #e82637;
					}

				}

				.item_btn {
					// width: 24%;
					// width: 100%;
					// text-align: right;

					button {
						// min-width: 65px;
						width: 100%;
						// color: #f44844;
						color: #fff;
						padding: 8px;
						border-radius: 5px;
						font-size: 13px;
						// border: 1px solid #e82637;
						background-color: #a43d41;
					}

					.item_btn_over {
						color: #999;
						border: 1px solid #999;
					}
				}
			}
		}
	}

	/deep/ .van-tabs__line {
		height: 2px;
		background-color: #1989fa;
	}

	/deep/ .van-tab--active {
		color: #1989fa;
	}

	.show-body {
		padding: 20px;
		font-size: 14px;

		.sw-label {
			margin-bottom: 10px;
		}

		.sw-bar {
			display: flex;
			align-items: center;
			background-color: #f5f5f5;
			padding: 10px;
			border-radius: 4px;

			.flex_bd {
				color: #999999;
			}
		}
	}

	.sw-bar .van-cell {
		padding: 0;
		background-color: transparent;
	}

	.sw-grid {
		display: flex;
		align-items: flex-end;
		margin-top: 20px;

		.sw-row:first-child {
			margin-bottom: 20px;
		}

		.sw-row>div:first-child {
			margin-bottom: 10px;
		}

		.sw-info {
			color: #999;
		}

		.sw-val.text-green {
			font-size: 16px;
		}
	}

	.sw-right {
		text-align: center;

		.sw-lg {
			font-size: 24px;
			margin-bottom: 10px;
		}
	}

	.flex_bd {
		flex: 1;
	}

	.payment-container {
		max-width: 500px;
		margin: 0 auto;
		background: #fff;
		padding: 20px;
		border-radius: 8px;
	}

	.payment-container span {
		color: #585858;
		font-size: 15px;
		font-weight: 600;
	}

	.payment-method {
		display: flex;
		align-items: center;
		padding: 15px;
		border: 1px solid #ddd;
		border-radius: 8px;
		margin-bottom: 10px;
		cursor: pointer;
		transition: all 0.3s;
	}

	.payment-method.active {
		border-color: #1989fa;
		background-color: #f5faff;
	}

	.payment-method:first-of-type {
		margin-top: 15px;
	}

	.method-icon {
		width: 30px;
		height: 30px;
		margin-right: 15px;
	}

	.close-x {
		text-align: right;
		margin-right: 20px;
		position: relative;
		top: 20px;
	}
</style>